import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from 'syf-component-library/ui/patterns/Grid/Grid';
import Body from 'syf-component-library/ui/typography/Body';
import { staticIcons } from '../../../defaultTheme';
export const PaymentMethodIcon = styled(FontAwesomeIcon) `
  color: ${staticIcons.statementsIconPrimary};
`;
const NameWrapper = styled(Grid) `
  margin-left: 12px;
`;
const PaymentMethodName = ({ name, leftIcon }) => {
    return (_jsxs(Grid, Object.assign({ container: true }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 1 }, { children: _jsx(PaymentMethodIcon, { "aria-hidden": true, icon: leftIcon, size: "1x" }) })), _jsx(NameWrapper, Object.assign({ item: true, xs: 10 }, { children: _jsx(Body, Object.assign({ "data-cy": "payment-method-name", isInline: true }, { children: name })) }))] })));
};
export default PaymentMethodName;
